export default "__VITE_ASSET__CVl7VyXR__"